<template>
  <div class="page-business-consulting-add container">
    <div class="container-flex list-content">
      <div class="form-item">
        <div class="form-label">企业名称</div>
        <div class="form-input-box">
          <input
            :disabled="disabled"
            class="form-input"
            placeholder="企业名称"
            v-model="form.phone"
            maxlength="11"
            type="number"
          />
        </div>
      </div>
      <div class="form-item">
        <div class="form-label">所在地区</div>
        <div class="form-input-box" @click="openModelShow">
          <div class="form-input-flex">{{ regionname }}</div>
          <div class="v-center right-text" v-if="!disabled">
            <img
              class="right-icon"
              src="../../assets/image/my-cell-icon-right.png"
            />
          </div>
        </div>
      </div>

      <div class="form-item">
        <div class="form-label">企业资质</div>
        <div class="upload-img-box">
          <!-- <div class="img-box"></div>
          <div class="img-box"></div>
          <div class="img-box"></div>
          <div class="img-box">+</div> -->
          <van-uploader
            :max-count="6"
            @click.native="onFileClick"
            :disabled="disabled"
            :after-read="afterRead"
            :before-delete="beforeDelete"
            v-model="remarkImageUrl"
            multiple
          />
        </div>
      </div>
      <!-- <div class="form-item">
        <div class="form-label">审核状态</div>
        <div class="form-input-box">未审核</div>
      </div>
      <div class="form-item">
        <div class="form-label">审核意见</div>
        <div class="form-input-box">无</div>
      </div> -->
    </div>
    <div class="add-btn-box">
      <pi-button type="primary" :loading="loading" block @click="submitButtonAction"
        >提交保存</pi-button
      >
      <!-- <pi-button type="primary" :loading="loading" block @click="addClick"
        >修改资料</pi-button
      > -->
    </div>

    <pi-select-city ref="piSelectCity" @change="cityChange"></pi-select-city>
  </div>
</template>

<script>
import { submitAdvice, uploadImage } from "../../common/api/index";
import { Picker, Popup, Uploader } from "vant";
import piSelectCity from "@/components/pi-select-city/pi-select-city.vue";
import { photoCompress } from "../../common/utils";
let toast = null;
export default {
  name: "business-consulting-add",
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [piSelectCity.name]: piSelectCity,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      loading: false,
      form: {
        address: "",
        phone: "",
        type: "",
      },
      regionname: "请选择省市区",
      disabled: false,
      fileList: [],
      remarkImages: [],
      remarkImageUrl: [],
    };
  },
  methods: {

    bindMultiPickerChange: function (val) {
      console.log(val);
      this.modelShow = false;
    },
    openModelShow() {
      if (!this.disabled) {
        // let cityDataId = {
        //     provinceId: data.provinceId,
        //     cityId: data.cityId,
        //     regionId: data.regionId,
        //   };
        let piSelectCity = this.$refs.piSelectCity;
        piSelectCity.open();
      }
    },
    cityChange(data) {
      console.log(data);
    },
    onFileClick() {
      setTimeout(() => {
        this.disabled = false;
      }, 300);
      setTimeout(() => {
        this.disabled = true;
      }, 0);
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      // console.log(file);
      if (file.length > 1) {
        file.forEach((item) => {
          this.fileList.push(item.file);
        });
      } else {
        this.fileList.push(file.file);
      }
    },
    beforeDelete(file) {
      // console.log('before delete');
      // console.log(file);
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].name === file.file.name) {
          this.fileList.splice(i, 1);
          break;
        }
      }
      return true;
    },
    submitButtonAction() {
      // if (this.$common.isEmpty(this.message)) {
      //   this.$toast("反馈内容不能为空");
      //   return;
      // }
      toast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: "加载中...",
      });
      this.uploadImages()
        .then((response) => {
          this.remarkImages = [];
          response.forEach((item) => {
            let data = item.data;
            if (data.length > 0) {
              let image = data[0];
              this.remarkImages.push(image);
            }
          });

          return submitAdvice({
            content: this.message,
            contactPhone: this.userObject.phoneNo,
            feedBackType: this.typeList[this.selectColumns].itemKey,
            picturesParamList: this.remarkImages,
          });
        })
        .then(() => {
          toast.clear();
          this.$dialog
            .alert({
              title: "提交成功",
              confirmButtonText: "关闭",
              confirmButtonColor: "#999999",
              closeOnPopstate: true,
            })
            .then(() => {
              this.$router.go(-1);
            });
        })
        .catch((error) => {
          console.log(error);
          toast.clear();
          if (error.response && error.response.status === 413) {
            this.$toast("提交失败，图片太大了");
          }
          this.$toast("提交失败！");
        });
    },
    uploadImages() {
      let that = this;
      let uploadImageTaskArray = [];
      that.remarkImages = [];
      // console.log(that.remarkImages);
      let uploadSingleImage = (file) => {
        if (file.size / (1024 * 1024) > 3) {
          return new Promise((resolve, reject) => {
            photoCompress(
              file,
              {
                quality: (1024 * 1024 * 3.0) / file.size, //限制大小最大为3M
              },
              function (fileobj) {
                const fileData = new FormData();
                fileData.append(
                  "file",
                  fileobj,
                  "file_" + Date.parse(new Date()) + ".jpg"
                );
                uploadImage(fileData)
                  .then((response) => {
                    resolve(response);
                  })
                  .catch((error) => {
                    reject(error);
                  });
              }
            );
          });
        } else {
          const fileData = new FormData();
          fileData.append("file", file);
          return new Promise((resolve, reject) => {
            uploadImage(fileData)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                reject(error);
              });
          });
        }
      };

      this.fileList.forEach((item) => {
        uploadImageTaskArray.push(uploadSingleImage(item));
      });
      return Promise.all(uploadImageTaskArray);
    },
  },
  mounted() {
    let id = this.$route.query.id;
    if (id) {
      this.form.id = id;
      this.disabled = true;
    }
    // this.getMyMallAddress();
  },
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";
.page-business-consulting-add {
  .list-content {
    padding: 0.2rem;
    position: relative;
  }
  .form-item {
    display: flex;
    margin-top: 0.2rem;
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
  .form-item:first-child {
    margin-top: 0;
  }
  .form-label {
    width: 1.46rem;
    color: #000000;
    padding: 0.27rem 0;
  }
  .form-input-box {
    display: flex;
    flex: 1;
    background: #fafafa;
    border-radius: 0.12px;
    height: 0.9rem;
    padding: 0.27rem 0.2rem;
    box-sizing: border-box;
  }
  .upload-img-box {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
  }
  .upload-img-box .img-box {
    width: 1.5rem;
    height: 1rem;
    line-height: 0.9rem;
    margin-right: 0.12rem;
    border: 1px solid #e5e5e5;
    border-radius: 0.1rem;
    overflow: hidden;
    cursor: pointer;
    font-size: 0.38rem;
    text-align: center;
    color: #999;
    margin-bottom: 0.12rem;
  }
  .upload-img-box .img-box .img {
    width: 100%;
    height: 100%;
  }
  .upload-img-box .img-box:last-child {
    margin-right: 0;
  }
  .form-input-flex {
    flex: 1;
  }
  .form-input,
  .form-textarea {
    width: 100%;
    background: transparent;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #000000;
  }
  .form-textarea {
    height: 1.8rem;
  }
  .right-icon {
    width: 0.12rem;
    height: 0.21rem;
  }
  .address-right-icon {
    width: 0.32rem;
    height: 0.39rem;
  }
  .add-btn-box {
    padding: 0.2rem;
  }
}
</style>
